import i18n from '../i18n/config';

/**
 * Maps backend messages to translation keys
 * This allows us to translate backend API response messages
 */
const messageTranslationMap = {
  // Success messages
  'Login success': 'apiMessages.loginSuccess',
  'Logout successful': 'apiMessages.logoutSuccessful',
  'Asset added successfully': 'apiMessages.assetAddedSuccessfully',
  'Asset updated successfully': 'apiMessages.assetUpdatedSuccessfully',
  'Asset deleted successfully': 'apiMessages.assetDeletedSuccessfully',
  'Server added successfully': 'apiMessages.serverAddedSuccessfully',
  'Server updated successfully': 'apiMessages.serverUpdatedSuccessfully',
  'Servers deleted successfully': 'apiMessages.serversDeletedSuccessfully',
  'System user added successfully': 'apiMessages.systemUserAddedSuccessfully',
  'System user updated successfully': 'apiMessages.systemUserUpdatedSuccessfully',
  'System users allocated successfully': 'apiMessages.systemUsersAllocatedSuccessfully',
  'User created successfully': 'apiMessages.userCreatedSuccessfully',
  'The user has been updated': 'apiMessages.userUpdated',
  'All selected users were deleted successfully': 'apiMessages.userDeleted',
  'All custom users were deleted successfully': 'apiMessages.deletedAllUsers',
  'User Role created successfully': 'apiMessages.userRoleCreated',
  'User Role updated successfully': 'apiMessages.userRoleUpdated',
  'User roles were deleted successfully': 'apiMessages.deletedRole',
  'All custom roles were deleted successfully': 'apiMessages.deletedAllRoles',
  'App added successfully': 'apiMessages.appAddedSuccessfully',
  'App updated successfully': 'apiMessages.appUpdatedSuccessfully',
  'App deleted successfully': 'apiMessages.appDeletedSuccessfully',
  'Web app added successfully': 'apiMessages.webAppAddedSuccessfully',
  'Web app updated successfully': 'apiMessages.webAppUpdatedSuccessfully',
  'Web app deleted successfully': 'apiMessages.webAppDeletedSuccessfully',
  'SSO Preference saved successfully.': 'apiMessages.ssoPreferenceSave',
  'OAuthserver information and preference saved successfully.': 'apiMessages.ssoOauthServerAdded',
  'OAuthserver information updated successfully.': 'apiMessages.ssoOauthServerUpdated',
  'SSO enabled for PAM solution.': 'apiMessages.ssoEnabled',
  'SSO disabled for PAM solution.': 'apiMessages.ssoDisabled',
  'Customer\'s miniOrange configuration saved successfully.': 'apiMessages.apiSavedSuccessfully',
  'License Details Updated Successfully': 'apiMessages.licenseUpdated',
  
  // Error messages
  'Invalid Username or Password': 'apiMessages.emailOrPasswordNotValid',
  'Server is unable to process your request for now, Please connect to the administrator': 'apiMessages.serverSideErrorConnectToAdmin',
  'Asset does not exists': 'apiMessages.assetDoesNotExists',
  'System user does not exists': 'apiMessages.systemUserDoesNotExists',
  'User does not exist': 'apiMessages.userDoesNotExist',
  'Role does not exist': 'apiMessages.roleDoesNotExist',
  'Bad request parameters': 'apiMessages.badRequestParam',
  'Operation not allowed': 'apiMessages.differentUserViewForbidden',
  'Customeradmin and Enduser role cannot be deleted': 'apiMessages.adminEnduserForbidDelete',
  'Role Display name already exists': 'apiMessages.userRoleExists',
  'Server cannot or will not process the request': 'apiMessages.httpBadRequest',
  'Internal server error, request cannot be processed': 'apiMessages.internalServerError',
  'Role can not be deleted': 'apiMessages.cannotDeleteRole',
  'Role display name cannot be empty': 'apiMessages.roleDisplayName',
  'Admin user cannot be deleted': 'apiMessages.adminDelete',
  'You cannot create or update an admin user': 'apiMessages.adminUserUnique',
  'Username already exists': 'apiMessages.usernameNotAvailable',
  'Email already exists': 'apiMessages.emailNotAvailable',
  'OAuthserver information does not exist.': 'apiMessages.ssoEntryDoesNotExist',
  'Email is missing in attribute mapping.': 'apiMessages.ssoEmailNotInAttributeMapping',
  'API key does not exist. Save correct Xecurify cloud information.': 'apiMessages.apiDoesNotExist',
  'Error in saving customer\'s miniOrange api key.': 'apiMessages.errorInCustomerMiniorangeApiSave',
  'Invalid Server Url': 'apiMessages.invalidServerUrl',
  'Wrong configuration provided. Please recheck configuration': 'apiMessages.wrongConfiguration',
  'Failed to verify 2FA credentials': 'apiMessages.failedToVerify2fa',
  'Fill all the fields in the advance option': 'apiMessages.fieldsDoesNotExists',
  'Scoper API key does not exists': 'apiMessages.scopeApiKeyDoesNotExists',
  
  // License messages
  '1001 - Your License has Expired. Please Contact miniorange.com to renew the License': 'apiMessages.licenseExpired',
  '1002 - User Limit Reached. Please Contact miniorange.com to extend the user limit': 'apiMessages.userLimitReached',
  '1002 - Asset Limit Reached. Please Contact miniorange.com to extend the asset limit': 'apiMessages.assetLimitReached',
  '1002 - App Limit Reached. Please Contact miniorange.com to extend the app limit': 'apiMessages.appLimitReached',
  '1002 - The number of Users uploaded exceeds the User Limit': 'apiMessages.bulkUserLimitReached',
  '1003 - The number of users for this License has exceeded. Please Contact miniorange.com to extend the user limit': 'apiMessages.userLimitExceeded',
  '1003 - The number of assets for this License has exceeded. Please Contact miniorange.com to extend the asset limit': 'apiMessages.assetLimitExceeded',
  '1003 - The number of apps for this License has exceeded. Please Contact miniorange.com to extend the app limit': 'apiMessages.appLimitExceeded',
  'Error - 1001': 'apiMessages.licenseExpiredEnduser',
  'Error - 1002': 'apiMessages.userLimitReachedEnduser',
  'Error - 1003': 'apiMessages.userLimitExceededEnduser',
  '1004 - License Details Updated Successfully': 'apiMessages.licenseUpdated',
  
  // Group messages
  'Group created successfully': 'apiMessages.groupCreated',
  'Group created Successfully': 'apiMessages.groupCreated',
  'Group updated successfully': 'apiMessages.groupUpdated',
  'Group updated Successfully': 'apiMessages.groupUpdated',
  'Groups were deleted successfully': 'apiMessages.groupDeleted',
  'Groups were deleted Successfully': 'apiMessages.groupDeleted',
  'Group does not exist': 'apiMessages.groupDoesNotExist',
  'Group already exists': 'apiMessages.groupExists',
  'Users added successfully': 'apiMessages.usersAdded',
  'Users removed successfully': 'apiMessages.usersRemoved',
  'Groups added successfully': 'apiMessages.groupsAdded',
  'Groups removed successfully': 'apiMessages.groupsRemoved',
  'Roles added successfully': 'apiMessages.rolesAdded',
  'Roles removed successfully': 'apiMessages.rolesRemoved',
  'Default group cannot be updated': 'apiMessages.defaultGroupCannotUpdated',
  
  // Ticket messages
  'Ticket raised Successfully': 'apiMessages.ticketRaised',
  'Ticket Updated Successfully': 'apiMessages.ticketUpdated',
  'Ticket Deleted Successfully': 'apiMessages.ticketDeleted',
  'Ticket does not exists': 'apiMessages.ticketDoesNotExist',
  'Ticket details are valid': 'apiMessages.validTicketDetails',
  'Ticket raised Successfully but unfortunately an exception occurred while sending the mail': 'apiMessages.ticketRaisedButMailIssue',
  'Ticket Column Preferences saved successfully': 'apiMessages.ticketColumnPreferencesSaved',
  'Ticket Column Preferences updated successfully': 'apiMessages.ticketColumnPreferencesUpdated',
  'Ticket columns details does not exist': 'apiMessages.ticketColumnDetailsDoesNotExist',
  'Ticket status is closed cannot update the ticket': 'apiMessages.ticketCannotBeUpdated',
  
  // Settings messages
  'Product Settings have been updated': 'apiMessages.settingsUpdated',
  'Ticket Settings have been updated': 'apiMessages.ticketSettingsUpdated',
  'The Setting does not exist': 'apiMessages.settingNotExists',
  
  // LDAP messages
  'Ldap bind account is valid': 'apiMessages.validLdapAccount',
  'Ldap bind account is invalid': 'apiMessages.invalidLdapAccount',
  'Ldap domain is valid': 'apiMessages.ldapDomainValid',
  'Ldap domain is invalid': 'apiMessages.ldapDomainInvalid',
  'Ldap Configuration does not exist': 'apiMessages.ldapConfigurationDoesNotExist',
  'Ldap Configuration created successfully': 'apiMessages.ldapConfigurationCreated',
  'Ldap Configuration already exists': 'apiMessages.ldapConfigurationExists',
  'Ldap Configuration updated successfully': 'apiMessages.ldapConfigurationUpdated',
  'Ldap Configuration Name already exists': 'apiMessages.ldapNameExists',
  'Configurations deleted successfully': 'apiMessages.ldapConfigurationDeleted',
  'Default Authentication set successfully': 'apiMessages.ldapAdSetAsDefaultAuthentication',
  'Default Authentication removed successfully': 'apiMessages.ldapAdRemoveAsDefaultAuthentication',
  'Connection to LDAP was successful': 'apiMessages.ldapConnectionSuccessful',
  'LDAP Authentication - Invalid username or password.': 'apiMessages.ldapInvalidUsernameOrPassword',
  'Could not find the user with the given username.': 'apiMessages.ldapUserNotFound',
  'Invalid AD scheme. Supported AD schemes are ldap and ldaps only.': 'apiMessages.invalidAdScheme',
  
  // Network Configuration messages
  'Network configuration does not exist': 'apiMessages.networkConfigurationDoesNotExist',
  'Network configuration added successfully': 'apiMessages.networkConfigurationAdded',
  'Network configuration updated successfully': 'apiMessages.networkConfigurationUpdated',
  'Network configurations deleted successfully': 'apiMessages.networkConfigurationsDeleted',
  'Network scan results deleted successfully': 'apiMessages.networkScanResultsDeleted',
  'Scanned results added successfully': 'apiMessages.scannedResultsAdded',
  'Unable to initiate network scan. Maximum scan limit reached.': 'apiMessages.maxScanLimitReached',
  'Network scan initiated. You will receive an email once it\'s done.': 'apiMessages.networkScanStarted',
  'Network scan started. Email gateway is disabled or not configured, so no email will be sent.': 'apiMessages.networkScanStartedWithoutEmail',
  'Network tested : Reachable': 'apiMessages.networkReachable',
  'Network tested : Not Reachable': 'apiMessages.networkNotReachable',
  'Network tested : Invalid subnet format': 'apiMessages.invalidSubnetFormat',
  
  // Password Policy messages
  'Password policy updated successfully.': 'apiMessages.passwordPolicyUpdatedSuccessfully',
  'Password policy created successfully.': 'apiMessages.passwordPolicyCreateSuccessfully',
  'Password policy object does not exist.': 'apiMessages.passwordPolicyDoesNotExist',
  'Password is not valid as per the policy.': 'apiMessages.passwordInvalidAgainstPolicy',
  'User password is expired.': 'apiMessages.passwordExpired',
  'Error in decrypting secrets from vault.': 'apiMessages.errorInDecryptingSecretsFromVault',
  'Error in encryption and storage of secrets in vault': 'apiMessages.errorInEncryptionAndStorageOfSecrets',
  'Update password email send failure.': 'apiMessages.updatePasswordEmailSendFailure',
  'Password vault object not exist.': 'apiMessages.passwordVaultObjDoesNotExist',
  'Password Vault Configurations stored successfully.': 'apiMessages.passwordVaultConfigurationsStoredSuccessfully',
  'All password policies are deleted successfully.': 'apiMessages.deleteAllPasswordPolicies',
  'Default password policy cannot be deleted': 'apiMessages.defaultPasswordPolicyDelete',
  'All custom password policies are deleted except default.': 'apiMessages.deletedPartialPasswordPolicies',
  'All selected password policies are deleted successfully': 'apiMessages.passwordPoliciesDeleted',
  
  // Password Rotation Policy messages
  'Password rotation policy created successfully': 'apiMessages.passwordRotationPolicyCreateSuccessfully',
  'Password rotation policy already exists': 'apiMessages.passwordRotationPolicyExists',
  'Password rotation policy object does not exist': 'apiMessages.passwordRotationPolicyDoesNotExist',
  'Password rotation policy deleted successfully': 'apiMessages.passwordRotationPolicyDeleteSuccessfully',
  'Password rotation policy updated successfully': 'apiMessages.passwordRotationPolicyUpdateSuccessfully',
  'Password rotated successfully': 'apiMessages.passwordRotatedSuccessfully',
  'Manual password rotation started': 'apiMessages.manualPasswordRotation',
  'Could not update password for the system user': 'apiMessages.couldNotUpdatePassword',
  'LDAPS is mandatory for updating user password': 'apiMessages.ldapsMandatoryToUpdatePassword',
  
  // MFA messages
  ' configured successfully.': 'apiMessages.mfaMethodConfiguredSuccessfully',
  'Incorrect OTP': 'apiMessages.incorrectOtp',
  'Miniorange user fetch failed,please check your miniorange configuration.': 'apiMessages.miniorangeUserFetchFailed',
  'Miniorange user create failed,please check your miniorange configuration.': 'apiMessages.miniorangeUserCreateFailed',
  'Miniorange user update failed,please check your miniorange configuration.': 'apiMessages.miniorangeUserUpdateFailed',
  'Miniorange user registration failed,please check your miniorange configuration.': 'apiMessages.miniorangeUserRegisterFailed',
  'Miniorange user challenge failed,please check your miniorange configuration.': 'apiMessages.miniorangeUserChallengeFailed',
  'Miniorange validation failed,please check your miniorange configuration.': 'apiMessages.miniorangeUserValidationFailed',
  'Error occurred during configuration of MFA.': 'apiMessages.mfaConfigurationError',
  'The Questions must be different from each other. Please check your inputs and try again.': 'apiMessages.kbaQuestionSameError',
  'Something went wrong in two fa challenge request.': 'apiMessages.somethingWentWrong2faChallenge',
  'Valida method not selected.': 'apiMessages.validMethodNotSelected',
  'Miniorange polling failed.': 'apiMessages.pollingFailed',
  'MFA method not configured.': 'apiMessages.mfaMethodNotConfigured',
  'Second factor disabled.': 'apiMessages.secondFactorDisabled',
  'Your configurations have been saved successfully.': 'apiMessages.configurationsSavedSuccessfully',
  'Method not allowed to Enable.': 'apiMessages.methodNotAllowedToEnable',
  'Method not allowed to Configure.': 'apiMessages.methodNotAllowedToConfigure',
  'Please set up your MFA first, and then try again.': 'apiMessages.pleaseConfigureMfaFirst',
  'Two-factor authentication has been successfully reset': 'apiMessages.reset2faSuccessful',
  'Disabling MFA is not allowed': 'apiMessages.disableMfaNotAllowed',
  
  // Certificate messages
  'Certificate not found': 'apiMessages.certificateNotFound',
  'Private key not found': 'apiMessages.privateKeyNotFound',
  'Certificate deleted successfully': 'apiMessages.certificateDeleted',
  'Certificate uploaded successfully': 'apiMessages.certificateUploaded',
  
  // Policy messages
  'Policy does not exists.': 'apiMessages.policyDoesNotExists',
  'Policies deleted successfully': 'apiMessages.policyDeleted',
  'Invalid input. Policy name cannot start with \'DEFAULT_\'.': 'apiMessages.policyNameInvalidInput',
  'SSH Policy created successfully': 'apiMessages.sshPolicyCreated',
  'SSH Policy updated successfully': 'apiMessages.sshPolicyUpdate',
  'Web App Policy created successfully': 'apiMessages.webAppPolicyCreatedSuccessfully',
  'Web App Policy updated successfully': 'apiMessages.webAppPolicyUpdatedSuccessfully',
  'Web App Policy deleted successfully': 'apiMessages.webAppPolicyDeletedSuccessfully',
  'Web App policy with this name already exists.': 'apiMessages.webAppPolicyNameAlreadyExists',
  
  // EPM Application Group messages
  'Application Group Not Found': 'apiMessages.epmApplicationGroupNotFound',
  'Application Group Already Exists': 'apiMessages.epmApplicationGroupAlreadyExists',
  'Application Group Name is Invalid': 'apiMessages.epmApplicationGroupInvalidName',
  'Application Group Name is Required': 'apiMessages.epmApplicationGroupNameRequired',
  'Application Group Description is Required': 'apiMessages.epmApplicationGroupDescriptionRequired',
  'Application Group ID is Required': 'apiMessages.epmApplicationGroupIdRequired',
  'Application Group Added successfully': 'apiMessages.epmApplicationGroupAdded',
  'Application Group Deleted successfully': 'apiMessages.epmApplicationGroupDeleted',
  'Application Group Updated successfully': 'apiMessages.epmApplicationGroupUpdated',
  'Application Group Added Failed': 'apiMessages.epmApplicationGroupAddFailed',
  'Application Group Delete Failed': 'apiMessages.epmApplicationGroupDeleteFailed',
  'Application Group Update Failed': 'apiMessages.epmApplicationGroupUpdateFailed',

  // EPM Application Definition messages
  'Application Definition Not Found': 'apiMessages.epmApplicationDefinitionNotFound',
  'Application Definition Already Exists': 'apiMessages.epmApplicationDefinitionAlreadyExists',
  'Application Definition Name is Invalid': 'apiMessages.epmApplicationDefinitionInvalidName',
  'Application Definition Name is Required': 'apiMessages.epmApplicationDefinitionNameRequired',
  'Application Definition Description is Required': 'apiMessages.epmApplicationDefinitionDescriptionRequired',
  'Application definitions fetched successfully': 'apiMessages.epmApplicationDefinitionsFetched',
  'Application Definition Added successfully': 'apiMessages.epmApplicationDefinitionAdded',
  'Application Definition Updated successfully': 'apiMessages.epmApplicationDefinitionUpdated',
  'Application Definition Deleted successfully': 'apiMessages.epmApplicationDefinitionDeleted',
  'Application Definition Added Failed': 'apiMessages.epmApplicationDefinitionAddFailed',
  'Application Definition Update Failed': 'apiMessages.epmApplicationDefinitionUpdateFailed',
  'Application Definition Delete Failed': 'apiMessages.epmApplicationDefinitionDeleteFailed',
  'Invalid Application ID(s)': 'apiMessages.epmInvalidApplicationIds',
  "Invalid action. Use 'assign' or 'unassign'": 'apiMessages.epmInvalidActionAssignOrUnassign',
  'Application group is referenced by other entities': 'apiMessages.epmApplicationGroupReferencedByOtherEntities',
  'Application definition is referenced by other entities': 'apiMessages.epmApplicationDefinitionReferencedByOtherEntities',

  // EPM Policy messages
  'Custom policy created successfully with all associations.': 'apiMessages.epmCustomPolicyCreatedWithAssociations',
  'An error occurred while creating the policy': 'apiMessages.epmErrorCreatingPolicy',

  // EPM Assignment success messages
  'Application group assigned to policy successfully': 'apiMessages.epmAppGroupAssignedToPolicy',
  'Application groups assigned to policy successfully': 'apiMessages.epmAppGroupsAssignedToPolicy',
  'Application group unassigned from policy successfully': 'apiMessages.epmAppGroupUnassignedFromPolicy',
  'Application groups unassigned from policy successfully': 'apiMessages.epmAppGroupsUnassignedFromPolicy',
  'Application definition assigned to policy successfully': 'apiMessages.epmAppDefAssignedToPolicy',
  'Application definitions assigned to policy successfully': 'apiMessages.epmAppDefsAssignedToPolicy',
  'Application definition unassigned from policy successfully': 'apiMessages.epmAppDefUnassignedFromPolicy',
  'Application definitions unassigned from policy successfully': 'apiMessages.epmAppDefsUnassignedFromPolicy',
  'Device assigned to policy successfully': 'apiMessages.epmDeviceAssignedToPolicy',
  'Device unassigned from policy successfully': 'apiMessages.epmDeviceUnassignedFromPolicy',
  'Devices assigned successfully to policy': 'apiMessages.epmDevicesAssignedToPolicy',
  'Device groups assigned successfully to policy': 'apiMessages.epmDeviceGroupsAssignedToPolicy',
  'Devices unassigned successfully from policy': 'apiMessages.epmDevicesUnassignedFromPolicy',
  'Device groups unassigned successfully from policy': 'apiMessages.epmDeviceGroupsUnassignedFromPolicy',
  'Device groups assigned to policy successfully': 'apiMessages.epmDeviceGroupsAssignedToPolicyAlt',
  'Device groups unassigned from policy successfully': 'apiMessages.epmDeviceGroupsUnassignedFromPolicyAlt',

  // EPM Selection error messages
  'No devices selected': 'apiMessages.epmNoDevicesSelected',
  'No device groups selected': 'apiMessages.epmNoDeviceGroupsSelected',
  'No users selected': 'apiMessages.epmNoUsersSelected',
  'No policies selected': 'apiMessages.epmNoPoliciesSelected',
  'No application group or policy selected': 'apiMessages.epmNoAppGroupOrPolicySelected',
  'No application definition or policy selected': 'apiMessages.epmNoAppDefOrPolicySelected',

  // EPM Weightage error messages
  'Fallback policy weightage cannot be edited': 'apiMessages.epmFallbackWeightageCannotEdit',
  'Please enter a weightage value.': 'apiMessages.epmEnterWeightageValue',
  'Please enter a valid numeric weightage.': 'apiMessages.epmEnterValidNumericWeightage',

  // EPM Agent/Device management messages
  'Failed to fetch agent versions': 'apiMessages.epmFailedToFetchAgentVersions',
  'Agent package downloaded successfully': 'apiMessages.epmAgentPackageDownloaded',
  'Action failed for all devices': 'apiMessages.epmActionFailedForAllDevices',
  'Action applied successfully': 'apiMessages.epmActionAppliedSuccessfully',
  'Failed to load OS types': 'apiMessages.epmFailedToLoadOsTypes',

  'EPM Policy created successfully': 'apiMessages.epmPolicyCreated',
  'EPM Policy updated successfully': 'apiMessages.epmPolicyUpdated',
  'EPM Policy deleted successfully': 'apiMessages.epmPolicyDeleted',
  'EPM Policy not found': 'apiMessages.epmPolicyNotFound',
  'This EPM Policy cannot be deleted': 'apiMessages.epmPolicyCannotDelete',
  'A policy with this weightage already exists for this customer.': 'apiMessages.epmPolicyWeightageExists',
  'Policy weightage updated successfully': 'apiMessages.epmPolicyWeightageUpdated',
  'Policy activated successfully': 'apiMessages.epmPolicyActivated',
  'Policy deactivated successfully': 'apiMessages.epmPolicyDeactivated',
  'Policy name updated successfully': 'apiMessages.epmPolicyNameUpdated',
  'Policy description updated successfully': 'apiMessages.epmPolicyDescriptionUpdated',
  'Policy action updated successfully': 'apiMessages.epmPolicyActionUpdated',
  'Policy OS type updated successfully': 'apiMessages.epmPolicyOsTypeUpdated',
  'Policy associations updated successfully': 'apiMessages.epmPolicyAssociationsUpdated',
  'Policy with this name already exists': 'apiMessages.epmPolicyNameExists',
  'No policy IDs provided for deletion': 'apiMessages.epmPolicyNoIdsProvided',
  'Cannot delete policies as they are referenced by other objects': 'apiMessages.epmPolicyProtectedDelete',
  'Cannot delete policy as it is referenced by other objects': 'apiMessages.epmPolicySingleProtectedDelete',
  'Policy management is not allowed': 'apiMessages.epmPolicyManagementNotAllowed',
  'Fallback policy management is not allowed': 'apiMessages.epmFallbackPolicyManagementNotAllowed',
  'Fallback policy device management is not allowed': 'apiMessages.epmFallbackPolicyDeviceManagementNotAllowed',
  'Fallback policy device assignment is not allowed': 'apiMessages.epmFallbackPolicyDeviceAssignmentNotAllowed',
  'Fallback policy device unassignment is not allowed': 'apiMessages.epmFallbackPolicyDeviceUnassignmentNotAllowed',
  'Fallback policy device group management is not allowed': 'apiMessages.epmFallbackPolicyDeviceGroupManagementNotAllowed',
  'Fallback policy device group assignment is not allowed': 'apiMessages.epmFallbackPolicyDeviceGroupAssignmentNotAllowed',
  'Fallback policy user management is not allowed': 'apiMessages.epmFallbackPolicyUserManagementNotAllowed',
  'Fallback policy user assignment is not allowed': 'apiMessages.epmFallbackPolicyUserAssignmentNotAllowed',
  "Only 'action' field can be updated for fallback policies": 'apiMessages.epmFallbackPolicyOnlyActionUpdate',
  'Fallback policies cannot be deleted': 'apiMessages.epmFallbackPoliciesCannotBeDeleted',
  'POST method not allowed with policy_id': 'apiMessages.epmPostNotAllowedWithPolicyId',
  'Policy ID is required for PUT operation': 'apiMessages.epmPolicyIdRequiredForPut',

  // EPM Policy Association messages
  'EPM Policy device association created successfully': 'apiMessages.epmPolicyDeviceAssociationCreated',
  'EPM Policy device group association created successfully': 'apiMessages.epmPolicyDeviceGroupAssociationCreated',
  'EPM Policy user group association created successfully': 'apiMessages.epmPolicyUserGroupAssociationCreated',
  'EPM Policy user association created successfully': 'apiMessages.epmPolicyUserAssociationCreated',
  'EPM Policy application group association created successfully': 'apiMessages.epmPolicyApplicationGroupAssociationCreated',
  'EPM Policy application definition association created successfully': 'apiMessages.epmPolicyApplicationDefinitionAssociationCreated',
  'Device is already associated with this policy': 'apiMessages.epmDeviceAlreadyAssociated',
  'Device group is already associated with this policy': 'apiMessages.epmDeviceGroupAlreadyAssociated',
  'User group is already associated with this policy': 'apiMessages.epmUserGroupAlreadyAssociated',
  'User is already associated with this policy': 'apiMessages.epmUserAlreadyAssociated',
  'Application group is already associated with this policy': 'apiMessages.epmApplicationGroupAlreadyAssociated',
  'Application definition is already associated with this policy': 'apiMessages.epmApplicationDefinitionAlreadyAssociated',

  // EPM Policy validation messages
  'Invalid pagination parameters': 'apiMessages.epmInvalidPaginationParameters',
  'Invalid Device ID(s)': 'apiMessages.epmInvalidDeviceIds',
  'Devices already assigned to policy': 'apiMessages.epmDevicesAlreadyAssignedToPolicy',
  'Invalid Policy ID(s)': 'apiMessages.epmInvalidPolicyIds',
  'Policies already assigned to device': 'apiMessages.epmPoliciesAlreadyAssignedToDevice',
  'Either policy_id or device_id must be provided': 'apiMessages.epmEitherPolicyOrDeviceIdRequired',
  "Status must be 'assigned' or 'unassigned'": 'apiMessages.epmStatusMustBeAssignedOrUnassigned',
  'Invalid Device Group ID(s)': 'apiMessages.epmInvalidDeviceGroupIds',
  'Device groups already assigned to policy': 'apiMessages.epmDeviceGroupsAlreadyAssignedToPolicy',
  'Policies already assigned to device group': 'apiMessages.epmPoliciesAlreadyAssignedToDeviceGroup',
  'Either policy_id or device_group_id must be provided': 'apiMessages.epmEitherPolicyOrDeviceGroupIdRequired',
  'Invalid User ID(s)': 'apiMessages.epmInvalidUserIds',
  'Users already assigned to policy': 'apiMessages.epmUsersAlreadyAssignedToPolicy',
  'Policies already assigned to user': 'apiMessages.epmPoliciesAlreadyAssignedToUser',
  'Either policy_id or user_id must be provided': 'apiMessages.epmEitherPolicyOrUserIdRequired',
  "Invalid entity type. Use 'policy' or 'application_group'": 'apiMessages.epmInvalidEntityTypePolicyOrAppGroup',
  'target_ids is required': 'apiMessages.epmTargetIdsRequired',
  'Invalid Application Group ID(s)': 'apiMessages.epmInvalidApplicationGroupIds',
  'Invalid application group IDs': 'apiMessages.epmInvalidApplicationGroupIdsAlt',
  "Invalid entity type. Use 'policy' or 'application_definition'": 'apiMessages.epmInvalidEntityTypePolicyOrAppDef',
  'Invalid Application Definition ID(s)': 'apiMessages.epmInvalidApplicationDefinitionIds',
  'Invalid application definition IDs': 'apiMessages.epmInvalidApplicationDefinitionIdsAlt',
  'One or more application groups not found': 'apiMessages.epmOneOrMoreApplicationGroupsNotFound',
  'One or more application definitions not found': 'apiMessages.epmOneOrMoreApplicationDefinitionsNotFound',
  'One or more devices not found': 'apiMessages.epmOneOrMoreDevicesNotFound',
  'One or more device groups not found': 'apiMessages.epmOneOrMoreDeviceGroupsNotFound',
  'Invalid user ID': 'apiMessages.epmInvalidUserId',
  'One or more users not found': 'apiMessages.epmOneOrMoreUsersNotFound',
  'One or more user groups not found': 'apiMessages.epmOneOrMoreUserGroupsNotFound',
  "Invalid policy id's": 'apiMessages.epmInvalidPolicyIdsGeneral',
  'OS Type is required': 'apiMessages.epmOsTypeRequired',
  'OS Type not found': 'apiMessages.epmOsTypeNotFound',
  'No valid applications selected': 'apiMessages.epmNoValidApplicationsSelected',

  // EPM Device Group messages
  'Device group created successfully': 'apiMessages.epmDeviceGroupCreated',
  'Device group with this name already exists': 'apiMessages.epmDeviceGroupNameExists',
  'Device group ID is required': 'apiMessages.epmDeviceGroupIdRequired',
  'Device group updated successfully': 'apiMessages.epmDeviceGroupUpdated',
  'Device group IDs are required': 'apiMessages.epmDeviceGroupIdsRequired',
  'Device IDs are required': 'apiMessages.epmDeviceIdsRequired',
  'Device group not found': 'apiMessages.epmDeviceGroupNotFound',
  'Device not found': 'apiMessages.epmDeviceNotFound',
  'Device info not found': 'apiMessages.epmDeviceInfoNotFound',

  // EPM Device Status messages
  'Device approved successfully': 'apiMessages.epmDeviceApproved',
  'Device disabled successfully': 'apiMessages.epmDeviceDisabled',
  'Device enabled successfully': 'apiMessages.epmDeviceEnabled',
  'Device uninstalled successfully': 'apiMessages.epmDeviceUninstalled',
  'Device deleted successfully': 'apiMessages.epmDeviceDeleted',
  'Device can only be approved when status is pending': 'apiMessages.epmDeviceApproveOnlyPending',
  'Device can only be disabled when status is online': 'apiMessages.epmDeviceDisableOnlyOnline',
  'Device can only be enabled when status is disabled': 'apiMessages.epmDeviceEnableOnlyDisabled',
  'Device can only be uninstalled when status is pending or disabled': 'apiMessages.epmDeviceUninstallInvalidStatus',
  'Device can only be deleted when is_deletable is True': 'apiMessages.epmDeviceDeleteNotDeletable',
  'Agent status updated successfully': 'apiMessages.epmAgentStatusUpdated',
  'Device hash and customer id is required': 'apiMessages.epmDeviceHashAndCustomerIdRequired',
  'Device id and customer id are required': 'apiMessages.epmDeviceIdAndCustomerIdRequired',
  'An error occurred while processing the request': 'apiMessages.epmErrorProcessingRequest',
  'customer header and device hash is required': 'apiMessages.epmCustomerHeaderAndDeviceHashRequired',
  'Customer not found': 'apiMessages.epmCustomerNotFound',

  // EPM Agent/Download messages
  'Agent MSI file not found': 'apiMessages.epmAgentMsiNotFound',
  'Default EPM Scoped API Key not found': 'apiMessages.epmDefaultScopedApiKeyNotFound',
  'Failed to fetch Default EPM Scoped API Key': 'apiMessages.epmFailedToFetchDefaultScopedApiKey',
  'Failed to create download package': 'apiMessages.epmFailedToCreateDownloadPackage',
  'Invalid or expired download token': 'apiMessages.epmInvalidOrExpiredDownloadToken',
  'version and status fields are required': 'apiMessages.epmVersionAndStatusFieldsRequired',
  'status must be success, failed, or rolled_back': 'apiMessages.epmInvalidReportStatus',
  'Update report received': 'apiMessages.epmAgentUpdateReportReceived',

  // EPM License messages
  '1010 - Device Limit Exceeded. Please contact miniorange.com to extend the device limit': 'apiMessages.epmDeviceLimitExceeded',
  '1009 - Device Limit Reached. Please contact miniorange.com to extend the device limit': 'apiMessages.epmDeviceLimitAtCapacity',
  'License has expired.': 'apiMessages.epmLicenseExpired',

  // EPM Update Plan messages
  'Update plan not found': 'apiMessages.epmUpdatePlanNotFound',
  'Update plan or ring not found': 'apiMessages.epmUpdatePlanOrRingNotFound',
  'Update plan created successfully': 'apiMessages.epmUpdatePlanCreated',
  'Update plan updated successfully': 'apiMessages.epmUpdatePlanUpdated',
  'Update plan activated successfully': 'apiMessages.epmUpdatePlanActivated',
  'Update plan paused successfully': 'apiMessages.epmUpdatePlanPaused',
  'Update plan resumed successfully': 'apiMessages.epmUpdatePlanResumed',
  'Update plan aborted successfully': 'apiMessages.epmUpdatePlanAborted',
  'Ring added to plan successfully': 'apiMessages.epmUpdatePlanRingAdded',
  'Ring updated successfully': 'apiMessages.epmUpdatePlanRingUpdated',
  'Ring deleted successfully': 'apiMessages.epmUpdatePlanRingDeleted',
  'Rings can only be added to a DRAFT plan': 'apiMessages.epmUpdatePlanRingsDraftOnlyAdd',
  'Rings can only be edited on a DRAFT plan': 'apiMessages.epmUpdatePlanRingsDraftOnlyEdit',
  'Rings can only be deleted from a DRAFT plan': 'apiMessages.epmUpdatePlanRingsDraftOnlyDelete',
  'Plan must be ACTIVE to advance a ring': 'apiMessages.epmUpdatePlanMustBeActive',
  'All rings complete. Plan marked COMPLETED': 'apiMessages.epmUpdatePlanAllRingsComplete',
  'Device status updated successfully': 'apiMessages.epmUpdatePlanDeviceStatusUpdated',
  'Update plan deleted successfully': 'apiMessages.epmUpdatePlanDeleted',
  'Only DRAFT and ABORTED plans can be deleted': 'apiMessages.epmUpdatePlanCannotDelete',
  
  // Allocation messages
  'App allocation extended successfully.': 'apiMessages.appAllocationExtend',
  'Asset allocation extended successfully': 'apiMessages.assetAllocationExtend',
  'Web app allocation extended successfully': 'apiMessages.webAppAllocationExtend',
  'Web app allocation successfully': 'apiMessages.webAppAllocation',
  'Apps Allocated Successfully': 'apiMessages.appsAllocated',
  'Assets Allocated Successfully': 'apiMessages.assetsAllocated',
  'Apps deallocated successfully': 'apiMessages.appsDeallocated',
  'Assets deallocated successfully': 'apiMessages.assetsDeallocated',
  'Groups Allocated Successfully': 'apiMessages.groupsAllocated',
  'Groups deallocated successfully': 'apiMessages.groupsDeallocated',
  'Default group can not be deallocated': 'apiMessages.defaultGroupDeallocate',
  'Users Deallocated successfully': 'apiMessages.usersDeallocatedAsset',
  'User deallocated successfully from app': 'apiMessages.userDeallocatedApp',
  'System users deallocated successfully': 'apiMessages.systemUsersDeallocatedSuccessfully',
  'Assets unboarded successfully': 'apiMessages.assetsUnboardedSuccessfully',
  'Resources updated successfully': 'apiMessages.resourcesUpdated',
  'Resources onboarded successfully': 'apiMessages.resourcesOnboarded',
  'Resources deleted successfully': 'apiMessages.resourcesDeletedSuccessfully',
  'Resources deleted partially': 'apiMessages.resourcesPartiallyDeletedSuccessfully',
  
  // Email messages
  'Email Configurations Updated': 'apiMessages.emailConfigurationsUpdated',
  'Password update email sent successfully.': 'apiMessages.emailSentSuccessfully',
  'Not able to send mail': 'apiMessages.mailNotSent',
  'Please enter a valid Email Address to test configuration.': 'apiMessages.enterValidEmailAddress',
  'Unable to connect to the specified Host. Please check your configuration.': 'apiMessages.enableToConnect',
  'Authentication with the remote SMTP server failed. Kindly check your credentials.': 'apiMessages.wrongCredentials',
  'Email template not found': 'apiMessages.emailTemplateNotFound',
  'Email template fetched successfully': 'apiMessages.emailTemplateFetchedSuccessfully',
  'Email template updated successfully': 'apiMessages.emailTemplateUpdatedSuccessfully',
  'Failed to update email template': 'apiMessages.failedToUpdateEmailTemplate',
  'Email configuration not found': 'apiMessages.emailConfigurationNotFound',
  'Test notification sent successfully': 'apiMessages.testNotificationSentSuccessfully',
  
  // User messages
  'User password updated successfully': 'apiMessages.userPasswordUpdated',
  'User does not exist!': 'apiMessages.userNotExist',
  'All custom users were deleted except Admin': 'apiMessages.deletedPartialUsers',
  'Admin role cannot be changed': 'apiMessages.adminRoleUnique',
  'System users deleted successfully': 'apiMessages.systemUserDeletedSuccessfully',
  'User with this username already exists': 'apiMessages.usernameTaken',
  'User with this email already exists': 'apiMessages.emailTaken',
  'User locked permanently': 'apiMessages.userLocked',
  'User unlocked successfully': 'apiMessages.userUnlocked',
  'Invalid request for user lock operation': 'apiMessages.invalidInputLocking',
  'Password and confirm password mismatch': 'apiMessages.passwordMismatch',
  'Password and confirm password not matched': 'apiMessages.passwordAndConfirmNotMatched',
  'User with this email or username not found': 'apiMessages.emailNotFound',
  'Admin user created successfully': 'apiMessages.adminCreated',
  'user bulk upload operation': 'apiMessages.userBulkUpload',
  'Successfully signed out of all devices': 'apiMessages.signedOutOfAllDevices',
  
  // App/Asset messages
  'App does not exist': 'apiMessages.appDoesNotExist',
  'Asset does not exist': 'apiMessages.assetDoesNotExist',
  'App already exists': 'apiMessages.appExists',
  'All selected apps were deleted successfully': 'apiMessages.appDeleted',
  'Database created successfully': 'apiMessages.databaseCreated',
  'Database updated successfully': 'apiMessages.databaseUpdated',
  'All selected databases were deleted successfully': 'apiMessages.databasesDeleted',
  'Web app does not exist': 'apiMessages.waDoesNotExists',
  'Web app asset updated successfully': 'apiMessages.webAppAssetUpdatedSuccessfully',
  
  // File/Upload messages
  'Invalid data file': 'apiMessages.invalidFile',
  'Successfully uploaded data': 'apiMessages.uploadSuccess',
  'File Size Limit exceeded': 'apiMessages.fileSizeLimitExceeded',
  'Selected file is not a csv': 'apiMessages.wrongFileFormat',
  'File not found': 'apiMessages.fileNotFound',
  'File not found or inaccessible': 'apiMessages.fileNotFoundOrInaccessible',
  'Invalid target path provided': 'apiMessages.invalidTargetPathProvided',
  'Uploaded file is empty': 'apiMessages.fileIsEmpty',
  'Data uploaded successfully.': 'apiMessages.dataUploadedSuccessfully',
  
  // Storage messages
  'Storage option not available.': 'apiMessages.storageOptionNotAvailable',
  'Storage configuration updated.': 'apiMessages.storageConfigurationUpdated',
  'Session Recording Deleted': 'apiMessages.sessionRecordingDeleted',
  
  // Other messages
  'Operational Error': 'apiMessages.operationalError',
  'An error occurred while connecting with the app. Please check the app configuration.': 'apiMessages.websocketConnectionFailed',
  'Invalid request, relaunch app to establish connection.': 'apiMessages.websocketInvalidConnectionRequest',
  'Access denied. Please access again from dashboard.': 'apiMessages.tabReopeningNotAllowed',
  'Domain changed successfully': 'apiMessages.organisationName',
  'Invalid Request': 'apiMessages.invalidRequest',
  'Invalid resource type': 'apiMessages.resourceTypeDoesNotExist',
  'Resource type not supported': 'apiMessages.resourceTypeNotSupported',
  'Invalid/missing attribute name': 'apiMessages.invalidAttributeName',
  'Response type or report type not defined or incorrect.': 'apiMessages.incorrectResponseOrReportType',
  'Please provide the valid \'field_name\' query parameter.': 'apiMessages.incorrectFieldName',
  'Response type not defined or incorrect.': 'apiMessages.incorrectResponseType',
  'Report type not defined or incorrect.': 'apiMessages.incorrectReportType',
  'No data found.': 'apiMessages.dataNotFound',
  'Invalid attributes for function.': 'apiMessages.invalidAttributes',
  'Entered expiry period is invalid': 'apiMessages.invalidExpiryPeriod',
  'Miniorange cloud configuration deleted successfully.': 'apiMessages.miniorangeCloudInfoDeletedSuccessfully',
  'External IDP application name should not be same as miniOrange.': 'apiMessages.externalApplicationNameEqualToMiniorange',
  'Attribute mapping for IDP failed.': 'apiMessages.attributeMappingFailed',
  'Miniorange user update not allowed': 'apiMessages.miniorangeUserUpdateNotAllowed',
  'Thank you for your query. We will respond to you via email shortly.': 'apiMessages.queryEmailSent',
  'User session closed. Login again and launch the application.': 'apiMessages.notValidSession',
  'Resource is not accessible for the current user, Contact Administrator to assign the asset.': 'apiMessages.resourceNotAccessible',
  'Unable to send your query. Please retry. For direct assistance, email us at info@xecurify.com.': 'apiMessages.queryMailFailure',
  'You do not have permission to access': 'apiMessages.permissionDenied',
  'Importing machines is disabled': 'apiMessages.importingMachinesDisabled',
  'Importing users is disabled': 'apiMessages.importUsersDisabled',
  'Importing groups is disabled': 'apiMessages.importGroupsDisabled',
  'Schedule reports configuration updated successfully': 'apiMessages.scheduleReportsUpdatedSuccessfully',
  // placeholder-bearing entry removed — matched by regexTranslationMap below
  'No Data Found to generate reports': 'apiMessages.noDataFoundForEmails',
  'Reports Generation time must be greater than 7 days': 'apiMessages.reportsInDays',
  
  // Client Credentials messages
  'Client Credential created successfully': 'apiMessages.clientCredentialCreated',
  'Client Credential audited successfully': 'apiMessages.clientCredentialAudited',
  'Client Credential already exists': 'apiMessages.clientCredentialExists',
  'Client Credential updated successfully': 'apiMessages.clientCredentialUpdated',
  'All selected Client Credentials deleted successfully': 'apiMessages.clientCredentialDeleted',
  'All selected Client Credentials deleted successfully; except default': 'apiMessages.clientCredentialPartialDeleted',
  'Client Credential does not exist': 'apiMessages.clientCredentialDoesNotExist',
  
  // OAuth Client messages
  'OAuth client does not exist': 'apiMessages.oauthClientDoesNotExist',
  'OAuth client with this name already exists': 'apiMessages.oauthClientWithThisNameAlreadyExists',
  'OAuth client created successfully': 'apiMessages.oauthClientCreatedSuccessfully',
  'OAuth client updated successfully': 'apiMessages.oauthClientUpdatedSuccessfully',
  'No client credentials provided': 'apiMessages.noClientCredentialsIdsProvided',
  'OAuth clients were deleted successfully': 'apiMessages.oauthClientDeletedSuccessfully',
  'Client credentials have expired': 'apiMessages.clientCredentialsHaveExpired',
  'Only client_credentials grant type is supported': 'apiMessages.unsupportedGrantType',
  'The requested resource is allocated as a one-time accessible resource and is already in use within an active session': 'apiMessages.resourceAlreadyInUseInOneTimeAccess',
  
  // Discovery messages
  'Access denied for the selected profile': 'apiMessages.discoveryAccessDenied',
  'Local Accounts discovery initiated. Check the status in the Status section.': 'apiMessages.discoveryStarted',
  'Onboarding process initiated': 'apiMessages.onboardProcessStarted',
  'Discovery profile does not exist': 'apiMessages.discoveryProfileDne',
  'Discovery job does not exist': 'apiMessages.discoveryJobDne',
  'Discovery profile added successfully': 'apiMessages.discoveryProfileAdded',
  'Discovery jobs removed successfully': 'apiMessages.discoveryJobsRemoved',
  'Discovery profile removed successfully': 'apiMessages.discoveryProfileRemoved',
  
  // SIEM messages
  'SIEM configuration does not exist': 'apiMessages.siemConfigurationDoesNotExist',
  'SIEM configuration added successfully': 'apiMessages.siemConfigurationAdded',
  'SIEM configurations deleted successfully': 'apiMessages.siemConfigurationsDeleted',
  // placeholder-bearing entry removed — matched by regexTranslationMap below
  
  // Branding messages
  'Branding domain does not exist.': 'apiMessages.brandingDomainDoesNotExist',
  'miniOrange account information does not exist.': 'apiMessages.miniorangeCloudInfoDoesNotExist',
  'miniOrange account information deletion call failed.': 'apiMessages.miniorangeAccountDeletionCallFailed',
  
  // Health Check messages
  'User invited successfully': 'apiMessages.healthCheckInviteUserSuccess',
  'User invite failed': 'apiMessages.healthCheckInviteUserUnsuccess',
  'Access revoked successfully': 'apiMessages.healthCheckDeleteUserSuccess',
  'Access revoke failed': 'apiMessages.healthCheckDeleteUserUnsuccess',
  'User list returned successfully': 'apiMessages.healthCheckListUserSuccess',
  'User list failed': 'apiMessages.healthCheckListUserUnsuccess',
  'Service status returned successfully': 'apiMessages.healthCheckServiceStatusSuccess',
  'Failed to retrieve storage information': 'apiMessages.healthCheckStorageSpaceFailed',
  
  // Validation messages
  'Maximum Invalid Attempts must be between 1 and 10': 'apiMessages.maxInvalidAttempts',
  'User Locking Interval must be between 1 min to 24 hrs (1440 min)': 'apiMessages.userLockInterval',
  'User Locked Time cannot be less than 1 min': 'apiMessages.userLockedTime',
  'User Session Logout period cannot be less than 1 min': 'apiMessages.userSessionTimeout',
  'The Record Session value provided is invalid': 'apiMessages.recordSession',
  'Select Port Range must be between 1 and 65535': 'apiMessages.selectPortRange',
  'The provided value for Multi-Factor Authentication (MFA) in relation to resource access is invalid.': 'apiMessages.mfaOverResource',
  'Missing email address in request.': 'apiMessages.emailDoesNotExistInRequest',
  'Role id is mandatory': 'apiMessages.noSuchRole',
  'Export data permission denied': 'apiMessages.exportDataPermissionDenied',
  'Import data permission denied': 'apiMessages.importDataPermissionDenied',
  'Unknown error occurred': 'apiMessages.unknownErrorOccurred',
  'Notification does not exist': 'apiMessages.notificationDoesNotExist',
  'User allocated successfully': 'apiMessages.userAllocated',
  'User removed successfully': 'apiMessages.userRemoved',
  'Role allocation time extended successfully': 'apiMessages.roleAllocationTimeExtendedSuccessfully',
  'Roles allocated successfully': 'apiMessages.rolesAllocatedSuccessfully',
  'Roles deallocated successfully': 'apiMessages.rolesDeallocatedSuccessfully',
  'Database Connection Successful': 'apiMessages.databaseTestConnectionSuccessful',
  'Test Connection Successful': 'apiMessages.testConnectionSuccessful',
  'Connection Failed, Check the Configurations': 'apiMessages.testConnectionUnsuccessful',
  'Test connection successful': 'apiMessages.testConnectionSuccessfulLower',
  'Test connection failed': 'apiMessages.testConnectionUnsuccessfulLower',
  'Export type parameter is required': 'apiMessages.exportTypeRequired',
  'Invalid export type. Must be \'group\' or \'role\'': 'apiMessages.invalidExportType',
  'Notification template fetched successfully': 'apiMessages.notificationTemplateFetchedSuccessfully',
  'Notification template updated successfully': 'apiMessages.notificationTemplateUpdatedSuccessfully',
  'System user fetched successfully': 'apiMessages.systemUserFetchedSuccessfully',
  'Successfully fetched active, inactive and offline user data': 'apiMessages.userDataFetchSuccess',
  'Missing expected key in request data or internal map': 'apiMessages.missingExpectedKey',
  'Invalid value encountered, possibly in input filters or during report generation': 'apiMessages.invalidValueEncountered',
  'List index out of range. Possibly accessing report data or email attachments': 'apiMessages.listIndexOutOfRange',
  'Object does not exist': 'apiMessages.objectDoesNotExist',
  // placeholder-bearing entry removed — matched by regexTranslationMap below
  'Resource partially onboarded, please review the errors.': 'apiMessages.partialResourceOnboarded',
  'Update expired user password': 'apiMessages.pamUpdateExpiredPassword',
  'All selected password policies are deleted except default and that in use': 'apiMessages.passwordPoliciesDeletedWithException',
  'Password policy is used in password rotation policy.': 'apiMessages.passwordPolicyInUse',
  'Incorrect current password': 'apiMessages.currentPasswordError',
  'Password updated successfully': 'apiMessages.passwordUpdated',
  'Entered new password same as current password': 'apiMessages.samePassword',
  'All notifications have been successfully marked as read.': 'apiMessages.allNotificationsMarkedAsRead',
  'Notification have been successfully marked as read.': 'apiMessages.notificationMarkedAsRead',
  
  // Threat Detection messages
  'Please Select the users for sending Alerts': 'apiMessages.alertUsersRequired',
  'Threat detection not configured': 'apiMessages.threatDetectionNotConfigured',
  'Threat detection learning is disabled': 'apiMessages.threatDetectionLearningDisabled',
  'Failed to fetch sessions at risk': 'apiMessages.failedToFetchSessionsAtRisk',
  'Failed to fetch threat detection statistics': 'apiMessages.failedToFetchThreatDetectionStatistics',
  'Failed to fetch threats blocked': 'apiMessages.failedToFetchThreatsBlocked',
  'threat_id is required': 'apiMessages.threatIdRequired',
  'Threat not found': 'apiMessages.threatNotFound',
  'Threat resolved successfully': 'apiMessages.threatResolvedSuccessfully',
  'Failed to resolve threat': 'apiMessages.failedToResolveThreat',
  'Failed to fetch alerts sent': 'apiMessages.failedToFetchAlertsSent',
  'alert_id is required': 'apiMessages.alertIdRequired',
  'status must be \'resolved\' or \'false_positive\'': 'apiMessages.statusMustBeResolvedOrFalsePositive',
  'Alert not found': 'apiMessages.alertNotFound',
  'Alert marked as resolved successfully': 'apiMessages.alertMarkedAsResolvedSuccessfully',
  'Alert marked as false_positive successfully': 'apiMessages.alertMarkedAsFalsePositiveSuccessfully',
  'Failed to update alert': 'apiMessages.failedToUpdateAlert',
  'Automated Response is required': 'apiMessages.automatedResponseRequired',
  'Threat detection configuration saved successfully': 'apiMessages.threatDetectionConfigurationSavedSuccessfully',
  'Failed to save threat detection configuration': 'apiMessages.failedToSaveThreatDetectionConfiguration',
  'Number of days must be at least 30 days': 'apiMessages.numberOfDaysMustBeAtLeast30',
  'Number of days must not exceed 365': 'apiMessages.numberOfDaysMustNotExceed365',
  'Minimum data points must be at least 20': 'apiMessages.minimumDataPointsMustBeAtLeast20',
  'Threshold percentage must be between 0 and 100': 'apiMessages.thresholdPercentageMustBeBetween0And100',
  'ML training time must be between 00:00 and 23:59': 'apiMessages.mlTrainingTimeMustBeBetween0000And2359',
  'ML confidence threshold must be between 0 and 1': 'apiMessages.mlConfidenceThresholdMustBeBetween0And1',
  'Timezone is required': 'apiMessages.timezoneRequired',
  'Invalid timezone:': 'apiMessages.invalidTimezone',
  'Timezone updated to': 'apiMessages.timezoneUpdatedTo',
  'Latitude and longitude are required': 'apiMessages.latitudeAndLongitudeRequired',
  'Invalid coordinate values': 'apiMessages.invalidCoordinateValues',
  'Invalid coordinate range': 'apiMessages.invalidCoordinateRange',
  'Location updated successfully': 'apiMessages.locationUpdatedSuccessfully',
  'Critical risk detected': 'apiMessages.criticalRiskDetected',
  'High risk behavior': 'apiMessages.highRiskBehavior',
  'Suspicious patterns': 'apiMessages.suspiciousPatterns',
  'Automated response must be one of:': 'apiMessages.automatedResponseMustBeOneOf',
  
  // Generic fallback
  'An unknown error occurred.': 'apiMessages.unknownError',
};

// Regex-based matchers for messages that contain user-controlled placeholders.
// Each entry: { pattern, key, params } where params is an array of capture-group names.
// The regex captures the dynamic parts; we pass them to i18n.t() as interpolation values.
const regexTranslationMap = [
  {
    pattern: /^(.+?) (.+?) Reports were sent to Emails Successfully$/i,
    key: 'apiMessages.reportsSentToEmailsSuccessfully',
    params: ['report_type', 'response_type'],
  },
  {
    pattern: /^SIEM configuration updated successfully by user (.+)\.$/i,
    key: 'apiMessages.siemConfigurationUpdated',
    params: ['user_name'],
  },
  {
    pattern: /^The asset '(.+)' cannot be deleted because it is currently assigned as an RDP machine for one or more web applications\.$/i,
    key: 'apiMessages.assetCannotDeleteUsedByWebapp',
    params: ['asset_name'],
  },
  // EPM dynamic messages
  {
    pattern: /^Successfully assigned (\d+) users? to policy$/i,
    key: 'apiMessages.epmSuccessfullyAssignedUsersToPolicy',
    params: ['count'],
  },
  {
    pattern: /^Successfully assigned (\d+) polic(?:y|ies) to user$/i,
    key: 'apiMessages.epmSuccessfullyAssignedPoliciesToUser',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) users? from policy$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedUsersFromPolicy',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) polic(?:y|ies) from user$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedPoliciesFromUser',
    params: ['count'],
  },
  {
    pattern: /^Successfully assigned (\d+) application groups? to policy$/i,
    key: 'apiMessages.epmSuccessfullyAssignedAppGroupsToPolicy',
    params: ['count'],
  },
  {
    pattern: /^Successfully assigned (\d+) polic(?:y|ies) to application group$/i,
    key: 'apiMessages.epmSuccessfullyAssignedPoliciesToAppGroup',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) application groups? from policy$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedAppGroupsFromPolicy',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) polic(?:y|ies) from application group$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedPoliciesFromAppGroup',
    params: ['count'],
  },
  {
    pattern: /^Successfully assigned (\d+) application definitions? to policy$/i,
    key: 'apiMessages.epmSuccessfullyAssignedAppDefsToPolicy',
    params: ['count'],
  },
  {
    pattern: /^Successfully assigned (\d+) polic(?:y|ies) to application definition$/i,
    key: 'apiMessages.epmSuccessfullyAssignedPoliciesToAppDef',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) application definitions? from policy$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedAppDefsFromPolicy',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) polic(?:y|ies) from application definition$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedPoliciesFromAppDef',
    params: ['count'],
  },
  {
    pattern: /^(\d+) device group\(s\) deleted successfully$/i,
    key: 'apiMessages.epmDeviceGroupsDeleted',
    params: ['count'],
  },
  {
    pattern: /^(\d+) device\(s\) added to group successfully$/i,
    key: 'apiMessages.epmDevicesAddedToGroup',
    params: ['count'],
  },
  {
    pattern: /^(\d+) device\(s\) removed from group successfully$/i,
    key: 'apiMessages.epmDevicesRemovedFromGroup',
    params: ['count'],
  },
  {
    pattern: /^No (.+) associations found to unassign$/i,
    key: 'apiMessages.epmNoAssociationsFoundToUnassign',
    params: ['item_name'],
  },
  {
    pattern: /^Advanced to ring (\d+)$/i,
    key: 'apiMessages.epmUpdatePlanAdvancedToRing',
    params: ['ring_order'],
  },
  {
    pattern: /^Missing required fields: (.+)$/i,
    key: 'apiMessages.epmUpdatePlanMissingRequiredFields',
    params: ['fields'],
  },
  {
    pattern: /^Invalid action\. Must be one of: (.+)$/i,
    key: 'apiMessages.epmDeviceStatusInvalidAction',
    params: ['actions'],
  },
  {
    pattern: /^(\d+) (.+)\(s\) assigned successfully$/i,
    key: 'apiMessages.epmItemAssignedSuccessfully',
    params: ['count', 'item_name'],
  },
  {
    pattern: /^(\d+) (.+)\(s\) unassigned successfully$/i,
    key: 'apiMessages.epmItemUnassignedSuccessfully',
    params: ['count', 'item_name'],
  },
  // EPM dynamic assignment messages
  {
    pattern: /^(\d+) user\(s\) assigned to policy successfully$/i,
    key: 'apiMessages.epmUsersAssignedToPolicyCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) user\(s\) unassigned from policy successfully$/i,
    key: 'apiMessages.epmUsersUnassignedFromPolicyCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) policy\(s\) assigned to user successfully$/i,
    key: 'apiMessages.epmPoliciesAssignedToUserCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) policy\(s\) unassigned from user successfully$/i,
    key: 'apiMessages.epmPoliciesUnassignedFromUserCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) polic(?:y|ies) assigned to application group successfully$/i,
    key: 'apiMessages.epmPoliciesAssignedToAppGroupCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) polic(?:y|ies) unassigned from application group successfully$/i,
    key: 'apiMessages.epmPoliciesUnassignedFromAppGroupCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) polic(?:y|ies) assigned to application definition successfully$/i,
    key: 'apiMessages.epmPoliciesAssignedToAppDefCount',
    params: ['count'],
  },
  {
    pattern: /^(\d+) polic(?:y|ies) unassigned from application definition successfully$/i,
    key: 'apiMessages.epmPoliciesUnassignedFromAppDefCount',
    params: ['count'],
  },
  {
    pattern: /^A policy with weightage (\S+) already exists for (.+)\. Please choose a different weightage\.$/i,
    key: 'apiMessages.epmPolicyWeightageExistsForOs',
    params: ['weightage', 'os_name'],
  },
  {
    pattern: /^Please select at least one (.+) to (assign|unassign)(?:\..+)?$/i,
    key: 'apiMessages.epmPleaseSelectAtLeastOne',
    params: ['item_type', 'action'],
  },
  {
    pattern: /^Are you sure you want to (assign|unassign) (?:this )?(?:\d+ )?(.+?) (to|from) the policy\?$/i,
    key: 'apiMessages.epmConfirmAssignUnassign',
    params: ['action', 'item_type', 'direction'],
  },
  {
    pattern: /^Successfully assigned (\d+) definitions? to application group$/i,
    key: 'apiMessages.epmSuccessfullyAssignedDefinitionsToAppGroup',
    params: ['count'],
  },
  {
    pattern: /^Successfully unassigned (\d+) definitions? from application group$/i,
    key: 'apiMessages.epmSuccessfullyUnassignedDefinitionsFromAppGroup',
    params: ['count'],
  },
  {
    pattern: /^Added (\d+) new application\(s\)$/i,
    key: 'apiMessages.epmAddedNewApplications',
    params: ['count'],
  },
];

// Bidi control characters that can be used to spoof displayed text.
// Strip them from any user-supplied string before it reaches the UI.
const BIDI_CONTROLS = /[‪-‮⁦-⁩‏‎؜]/g;

const stripBidi = (str) => (typeof str === 'string' ? str.replace(BIDI_CONTROLS, '') : str);

const resolveTranslation = (translationKey, trimmedMessage) => {
  const translated = i18n.t(translationKey);
  if (translated === translationKey || translated === `apiMessages.${translationKey.split('.').pop()}`) {
    return trimmedMessage;
  }
  return translated;
};

/**
 * Translates a backend message to the current language.
 * Strips bidi-control characters from the input before any lookup or display.
 * @param {string} message - The backend message
 * @returns {string} - The translated message or sanitised original if no translation found
 */
export const translateMessage = (message) => {
  if (!message || typeof message !== 'string') {
    return message;
  }

  const trimmedMessage = stripBidi(message.trim());

  // 1. Exact match
  if (messageTranslationMap[trimmedMessage]) {
    return resolveTranslation(messageTranslationMap[trimmedMessage], trimmedMessage);
  }

  // 2. Case-insensitive exact match
  const lowerMessage = trimmedMessage.toLowerCase();
  for (const [key, translationKey] of Object.entries(messageTranslationMap)) {
    if (key.toLowerCase() === lowerMessage) {
      return resolveTranslation(translationKey, trimmedMessage);
    }
  }

  // 3. Regex match for placeholder-bearing messages (user-controlled values interpolated safely)
  for (const { pattern, key, params } of regexTranslationMap) {
    const match = trimmedMessage.match(pattern);
    if (match) {
      const interpolation = {};
      params.forEach((name, i) => {
        interpolation[name] = stripBidi(match[i + 1]);
      });
      const translated = i18n.t(key, interpolation);
      if (translated === key) return trimmedMessage;
      return translated;
    }
  }

  // 4. Return sanitised original if no translation found
  return trimmedMessage;
};

/**
 * Translates an array of messages
 * @param {Array<string>} messages - Array of backend messages
 * @returns {Array<string>} - Array of translated messages
 */
export const translateMessages = (messages) => {
  if (!Array.isArray(messages)) {
    return messages;
  }
  return messages.map(msg => translateMessage(msg));
};

